var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"mt-4 mb-4"},[_vm._v(" "+_vm._s((_vm.value + " " + _vm.suffix))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }